import PoolFinder from '../views/PoolFinder'

export default PoolFinder
